const MuiTableCell = {
  root: {
    fontSize: '1.4rem',
  },
};

export default MuiTableCell;
